<template>
  <label class="flex cursor-pointer flex-col items-center">
    <input
      :checked="item.isRefined"
      :value="item.value"
      type="checkbox"
      class="size-0 border-0 focus:ring-0"
      @change="$emit('category-click')"
    />
    <div
      :style="{ 'background-image': imageUrl ? `url(${imageUrl})` : '' }"
      :class="{ 'border-[6px]': item.isRefined }"
      class="flex size-16 items-center justify-center rounded-full border-highlight bg-gray bg-cover bg-center"
    >
      <CheckIcon
        v-if="item.isRefined"
        class="size-8 font-bold text-highlight"
      />
    </div>
    <span
      :class="{ 'font-bold': item.isRefined }"
      :title="item.value"
      class="mt-2 inline-block w-full overflow-hidden text-ellipsis text-center"
      >{{ item.value }}</span
    >
  </label>
</template>

<script setup lang="ts">
import { AlgoliaCategory } from '@/types/Algolia/AlgoliaCategory';
import { CheckIcon } from '@heroicons/vue/16/solid';
import { computed } from 'vue';
import { AlgoliaFacetHit } from '@/types/Algolia/AlgoliaFacetHit';

export type SingleCategoryProps = {
  category?: AlgoliaCategory;
  item: AlgoliaFacetHit;
};

const props = defineProps<SingleCategoryProps>();
defineEmits(['category-click']);

const imageUrl = computed(() =>
  !!props.category ? props.category.imageUrl : null
);
</script>
